import { useState } from "react";
import { Box, Stack, Tab, Tabs } from "@mui/material";
import { useTranslate } from "src/locales/use-locales";
import ByzNurseSaveButton from "src/components/core-components/mui/buttons/ByzNurseButton/ByzNurseSaveButton";
import ByzNurseDeleteButton from "src/components/core-components/mui/buttons/ByzNurseButton/ByzNurseDeleteButton";
import ByzMuiAddButton from "src/components/core-components/mui/buttons/ByzMuiAddButton";
import ByzMuiButton from "src/components/core-components/mui/buttons/ByzMuiButton";
import PatientDatas from "../../patient-datas";
import PageOne from "./pages/page-one/page_one";
import PageTwo from "./pages/page-two/page_two";
import PageThree from "./pages/page-three/page_three";
import PageFour from "./pages/page-four/page_four";
import PageFive from "./pages/page-five/page_five";
import ByzMuiCloseButton from "src/components/core-components/mui/buttons/ByzMuiCloseButton";
import ByzMuiSnackBar from "src/components/core-components/mui/ByzMuiSnackBar";

function NewbornPatientAssessmentCreate() {
  const [activeTab, setActiveTab] = useState(0);

  const handleTabChange = async (tab: number) => {
    setActiveTab(tab);
  };

  const [alertOpen, setAlertOpen] = useState(false);
  const [alertMessage, setAlertMessage] = useState("");
  const [alertSeverity, setAlertSeverity] = useState<"error" | "success">("success");

  const showAlert = (message: string, severity: "error" | "success") => {
    setAlertMessage(message);
    setAlertSeverity(severity);
    setAlertOpen(true);
  };

  const handleSaveMedcard = async () => {
    try {
      const response = "Tıbbi kart başarıyla kaydedildi";
      console.log("Save API cevabı:", response);
      showAlert(response, "success");
    } catch (error) {
      console.error("Hata:", error);
      showAlert("Medcard kaydedilirken hata oluştu!", "error");
    }
  };

  const handleDeleteMedcard = async () => {
    try {
      const response = "Medcard Silindi";
      console.log("Delete API cevabı:", response);
      showAlert(response, "success");
    } catch (error) {
      console.error("Hata:", error);
      showAlert("Medcard silinirken hata oluştu!", "error");
    }
  };

  const handleAddMedcard = async () => {
    try {
      const response = "Medcard Eklendi";
      console.log("Delete API cevabı:", response);
      showAlert(response, "success");
    } catch (error) {
      console.error("Hata:", error);
      showAlert("Medcard Eklenirken hata oluştu!", "error");
    }
  };

  const { t } = useTranslate();

  return (
    <>
      <PatientDatas isOpenMedCard={true} isCreateMedCard={true} />
      <Stack
        sx={{ padding: "5px", marginBottom: "20px" }}
        mt={5}
        direction="row"
        spacing={2}
        justifyContent="space-between"
        alignItems="center"
      >
        <Stack direction="row" spacing={2}>
          <ByzNurseSaveButton onClick={handleSaveMedcard} />
          <ByzMuiAddButton onClick={handleAddMedcard} />
          <ByzNurseDeleteButton onClick={handleDeleteMedcard} />
          <ByzMuiButton
            onClick={() => console.log("Print")}
            sx={{
              backgroundColor: "#63B4FF33",
              color: "#2979C3",
              border: "1px solid #2979C3",
            }}
            icon={
              <img
                src="/assets/icons/buttons/adult-patient/delete_identifying_person.svg"
                alt="Delete Icon"
              />
            }
          >
            {t("newborn-patient-assessment.delete-identifying-person")}
          </ByzMuiButton>
        </Stack>
        <ByzMuiCloseButton onClick={() => console.log("Kapat")} />
      </Stack>

      <Box sx={{ padding: "20px", width: "100%" }}>
        <Stack>
          <Tabs
            className="ByzMuiTabs"
            sx={{
              marginBottom: 2,
            }}
            value={activeTab}
            onChange={(event, newValue) => handleTabChange(newValue)}
            aria-label="Tabs"
          >
            <Tab label={t("newborn-patient-assessment.page-one")} value={0} />
            <Tab label={t("newborn-patient-assessment.page-two")} value={1} />
            <Tab label={t("newborn-patient-assessment.page-three")} value={2} />
            <Tab label={t("newborn-patient-assessment.page-four")} value={3} />
            <Tab label={t("newborn-patient-assessment.page-five")} value={4} />
          </Tabs>

          {activeTab === 0 ? (
            <PageOne />
          ) : activeTab === 1 ? (
            <PageTwo />
          ) : activeTab === 2 ? (
            <PageThree />
          ) : activeTab === 3 ? (
            <PageFour />
          ) : activeTab === 4 ? (
            <PageFive /> 
          ) : null}
        </Stack>
      </Box>

      <ByzMuiSnackBar
        open={alertOpen}
        onClose={() => setAlertOpen(false)}
        title={
          alertSeverity === "success" ? t("operation-successful") : t("error")
        }
        message={alertMessage}
        type={alertSeverity}
      />
    </>
  );
}

export default NewbornPatientAssessmentCreate;